module.exports = __webpack_public_path__ + "img/jk-3.5e708c63.png";